export default class Toolbar {
    constructor() {
        this.listeners = new Set();
        this.toolbarDiv = document.getElementById("toolbar");
        this.bars = [
            document.createElement("div"),
            document.createElement("div"),
        ];
        this.bars.forEach(bar => {
            var _a;
            bar.classList.add("toolbar");
            (_a = this.toolbarDiv) === null || _a === void 0 ? void 0 : _a.appendChild(bar);
        });
    }
    onChange(app) {
        this.renderSecondaryBar(app);
    }
    render(data) {
        const [bar] = this.bars;
        bar.innerText = '';
        const { apps, appIndex = 0 } = data;
        apps.forEach((app, i) => {
            const { title } = app;
            const selected = i === appIndex;
            const div = document.createElement("div");
            div.classList.add("toolbar-item");
            if (selected) {
                div.classList.add('selected');
            }
            div.textContent = title !== null && title !== void 0 ? title : "untitled";
            if (!selected) {
                div.addEventListener("click", () => {
                    data.appIndex = i;
                    this.render(data);
                    this.onSceneChange(app, true);
                });
            }
            bar === null || bar === void 0 ? void 0 : bar.appendChild(div);
            if (selected) {
                this.renderSecondaryBar(app);
            }
        });
    }
    renderSecondaryBar(app) {
        const [, bar] = this.bars;
        bar.innerText = '';
        const { scenes, sceneIndex = 0 } = app;
        scenes === null || scenes === void 0 ? void 0 : scenes.forEach(({ title }, i) => {
            const selected = i === sceneIndex;
            const div = document.createElement("div");
            div.classList.add("toolbar-item");
            if (selected) {
                div.classList.add('selected');
            }
            div.textContent = title !== null && title !== void 0 ? title : "untitled";
            if (!selected) {
                div.addEventListener("click", () => {
                    app.sceneIndex = i;
                    this.renderSecondaryBar(app);
                    this.onSceneChange(app, false);
                });
            }
            bar === null || bar === void 0 ? void 0 : bar.appendChild(div);
        });
    }
    onSceneChange(app, changeApp) {
        this.listeners.forEach(listener => listener.onChange(app, changeApp));
    }
    hook(listener) {
        this.listeners.add(listener);
    }
}
